/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { forwardRef } from "react";
import { Box } from "@mui/system";
import { selectUser } from "../../store/userSlice";
import { useSelector } from "react-redux";

const CommentStatusSelect = forwardRef((props, ref) => {
  const { value, onChange, className } = props;

  const user = useSelector(selectUser);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const menuItems = [
    <MenuItem key="pending" value="pending" className="space-x-12">
      Pending (Submitted)
    </MenuItem>,
    <MenuItem key="disapproved" value="disapproved" className="space-x-12">
      Disapproved
    </MenuItem>
  ];
  
  if (user.role === "admin" || user.role === "leadReviewer") {
    menuItems.push(
      <MenuItem key="approvedWithComments" value="approvedWithComments" className="space-x-12">
        Approved with Comments
      </MenuItem>,
      <MenuItem key="approved" value="approved" className="space-x-12">
        Approved
      </MenuItem>
    );
  }
  
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="select-label">Status</InputLabel>
      <Select
        labelId="select-status"
        id="status"
        value={value}
        label="Status"
        onChange={handleChange}
        ref={ref}
        classes={{ select: "flex items-center space-x-12" }}
        defaultValue="pending"
      >
        {menuItems}
      </Select>
    </FormControl>
  );
});

export default CommentStatusSelect;
